$(document).ready(function () {

  // Recipe page slider
  $('.recipes_product_use_slider').slick({
   infinite: true,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 4,
   prevArrow: false,
   nextArrow: false,
   dots: false,
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 3,
         dots: true
       }
     },
     {
       breakpoint: 576,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         dots: true
       }
     }
  
   ]
 });

 $(".m-menu-mobile__item.custom-menu-link-mobile").each(function(){
   $(this).appendTo('ul.m-menu-drawer__navigation.m-menu-mobile');  
 });
 

 /* ---------- PLP show more Js ---------- */
 $('.moreless-button').click(function () {
     $('.moretext').slideToggle();
     if ($('.moreless-button').text() == "Read more") {
         $(this).text("Read less")
     } else {
         $(this).text("Read more")
     }
 });

 /* ---------- PDP page Js ---------- */

 $('.addon_btn_shipping').on('click',function(event){
   event.preventDefault();
     var targetElement = $(".m-tab-header");
     var mobTargetElement = $(".m-tab-content--liquid");     
   
      if ($(window).width() >= 768) {
          $("#tab-2").trigger("click");
          $('html, body').animate({
            scrollTop: targetElement.offset().top
          }, 1000);        
      }
      else{        
        $('#acco-2 .m-accordion--item-button').trigger("click");
        $('html, body').animate({
            scrollTop: mobTargetElement.offset().top
          }, 1000);        
      }
     
 });

 /* ---------- Home page Js ---------- */

 // cobber_type_section slider
 $('.cobber_type_boxes').slick({
     infinite: true,
     speed: 300,
     slidesToShow: 8,
     slidesToScroll: 8,
     prevArrow: false,
     nextArrow: false,
     responsive: [
       {
         breakpoint: 1370,
         settings: {
           slidesToShow: 6,
           slidesToScroll: 6,
           infinite: true,
           dots: true
         }
       },
       {
         breakpoint: 1200,
         settings: {
           slidesToShow: 5,
           slidesToScroll: 5,
           dots: true
         }
       },
       {
         breakpoint: 992,
         settings: {
           slidesToShow: 4,
           slidesToScroll: 4,
           dots: true
         }
       },
       {
         breakpoint: 576,
         settings: {
           slidesToShow: 3,
           slidesToScroll: 3,
           dots: true,
           autoplay: true,
           autoplaySpeed: 3000
         }
       },
       {
         breakpoint: 400,
         settings: {
             slidesToShow: 2,
             slidesToScroll: 2,
             dots: true,
             autoplay: true,
             autoplaySpeed: 3000
         }
       }
     ]
   });


   // Product highlights slider
 $('.product_highlights_box_slider').slick({
     infinite: true,
     speed: 300,
     slidesToShow: 3,
     slidesToScroll: 3,
     prevArrow: false,
     nextArrow: false,
     dots: false,
     responsive: [
       {
         breakpoint: 1024,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 2,
           autoplay: true,
           autoplaySpeed: 2000,
         }
       },
       {
         breakpoint: 576,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           autoplay: true,
           autoplaySpeed: 2000,
         }
       }
    
     ]
   });

   // Home Blog slider
 $('.template-index .m-blog-grid__wrapper .m-mixed-layout__inner').slick({
   infinite: true,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 3,
   prevArrow: false,
   nextArrow: false,
   dots: false,
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         dots: true
       }
     },
     {
       breakpoint: 576,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         dots: true
       }
     }
  
   ]
 });


  // Cobbers page slider
  $('.carousel_slides_wrapper').slick({
   infinite: true,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 3,
   prevArrow: false,
   nextArrow: false,
   dots: false,
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         dots: true
       }
     },
     {
       breakpoint: 576,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         dots: true
       }
     }
  
   ]
 });

$(document).on("click", function(event) {
  var $trigger = $(".currency_switcher_drpdown");
  if ($trigger !== event.target && !$trigger.has(event.target).length) {
    $(".currency_switcher_drpdown").children('li:not(.init)').slideUp("fast");
  }
});
//  Header js (currency switcher)
$(".currency_switcher_drpdown").on("click", ".init", function() {
  $(this).closest(".currency_switcher_drpdown").children('li:not(.init)').toggle();
});

var allOptions = $(".currency_switcher_drpdown").children('li:not(.init)');
$(".currency_switcher_drpdown").on("click", "li:not(.init)", function() {
  Confirm('Currency Switch', 'Are you sure you want to change store currency to '+ $(this).html() + ' ?', 'Yes', 'Cancel', allOptions, $(this));
  
  
  
});

function Confirm(title, msg, $true, $false, allOptions, $this) { /*change*/
        var $content =  "<div class='dialog-ovelay'>" +
                        "<div class='dialog'><header>" +
                         " <h3> " + title + " </h3> " +
                         "<i class='fa fa-close'></i>" +
                     "</header>" +
                     "<div class='dialog-msg'>" +
                         " <p> " + msg + " </p> " +
                     "</div>" +
                     "<footer>" +
                         "<div class='controls'>" +
                             " <button class='button button-danger doAction'>" + $true + "</button> " +
                             " <button class='button button-default cancelAction'>" + $false + "</button> " +
                         "</div>" +
                     "</footer>" +
                  "</div>" +
                "</div>";
         $('body').prepend($content);
      $('.doAction').click(function () {
        allOptions.removeClass('selected');
        $this.addClass('selected');
        $(".currency_switcher_drpdown").children('.init').html($this.html());
        allOptions.toggle();
        var currencyData = $this.data('value');
        $('#country_code').val(currencyData);
        $('#currencySwitcherForm').submit();
        $(this).parents('.dialog-ovelay').fadeOut(500, function () {
          $(this).remove();
        });
      });
$('.cancelAction, .fa-close').click(function () {
        $(this).parents('.dialog-ovelay').fadeOut(500, function () {
          $(this).remove();
        });
      });
      
   }
  
// $('a').click(function () {
//         Confirm('Go to Google', 'Are you sure you want to visit Google', 'Yes', 'Cancel', "https://www.google.com.eg"); /*change*/
//     });

 $('input[type=radio][name="Variant Name"]').change(function() {
    setTimeout(
      function() 
      {
          var amount = $('.m-price-item--sale').html();
       amount = amount.replace('$','');
        $('#paypal_message').delay( 5000 ).attr('data-pp-amount', amount);
      }, 1000);
   });  
});

// jQuery(window).resize(function () {
//     if(jQuery('#video_main_div').length > 0){         
//       myFunction();       
//     }
    
// });

function myFunction() {
    if (jQuery(window).width() <= 767) {
        var video_div = document.getElementById("mobile_video_div").innerHTML;
    } else{      
        var video_div = document.getElementById("desktop_video_div").innerHTML;
    }
    document.getElementById("video_main_div").innerHTML = video_div;
}